import { render, staticRenderFns } from "./datebox.vue?vue&type=template&id=8cc02ece&"
import script from "./datebox.vue?vue&type=script&lang=js&"
export * from "./datebox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports